import { Mail, Phone, MapPin } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { Seo, breadcrumbSchema } from "../components/Seo";
import { ContactForm } from "../components/Forms";
import { BRAND, CONTACT, SITE_URL } from "../lib/site";

const items = [
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
  { icon: Phone, label: "Phone", value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, "")}` },
  { icon: MapPin, label: "Location", value: CONTACT.location },
];

const SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    breadcrumbSchema([["Home", "/"], ["Contact", "/contact"]]),
    {
      "@type": "ContactPage",
      url: `${SITE_URL}/contact`,
      mainEntity: {
        "@type": "Organization",
        name: BRAND.name,
        url: SITE_URL,
        email: CONTACT.email,
        address: {
          "@type": "PostalAddress",
          addressLocality: CONTACT.city,
          addressRegion: CONTACT.region,
          addressCountry: CONTACT.country,
        },
      },
    },
  ],
};

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact Us"
        description={`Contact ${BRAND.name} in ${CONTACT.city}, India. Whether you are hiring or looking for your next opportunity, our recruitment team is ready to help.`}
        keywords="Contact Recruitment Agency, Staffing Company Chennai, Hiring Enquiry, Recruitment Consultancy Contact"
        schema={SCHEMA}
      />
      <PageHeader kicker="Contact" title="Let's Connect"
        sub="Whether you're hiring or looking for your next opportunity, our team is ready to help." />

      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-testid="contact-section">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <h2 className="text-2xl md:text-3xl font-bold text-navy">Reach our team</h2>
              <p className="mt-4 text-ink leading-relaxed">Send us a message and we'll get back to you shortly.</p>
              <ul className="mt-8 space-y-5">
                {items.map((it) => {
                  const Icon = it.icon;
                  return (
                    <li key={it.label} className="flex items-start gap-4" data-testid={`contact-${it.label.toLowerCase()}`}>
                      <span className="w-11 h-11 rounded-lg bg-navy text-white flex items-center justify-center shrink-0" aria-hidden="true">
                        <Icon size={20} />
                      </span>
                      <div>
                        <p className="text-xs uppercase tracking-wider text-slate-400">{it.label}</p>
                        {it.href ? (
                          <a href={it.href} className="font-semibold text-navy hover:text-sapphire transition-colors break-all">{it.value}</a>
                        ) : (
                          <address className="not-italic font-semibold text-navy">{it.value}</address>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <div className="bg-white border border-slate-200 rounded-xl p-6 md:p-8">
                <ContactForm />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
